export default {
  cwUrl: process.env.REACT_APP_LEGACY_EN,
  baseUrl: {
    en: process.env.REACT_APP_BASEURL_EN,
    cy: process.env.REACT_APP_BASEURL_CY
  },
  basePath: {
    en: process.env.REACT_APP_WHO_AM_I_BASEPATH_EN,
    cy: process.env.REACT_APP_WHO_AM_I_BASEPATH_CY
  },
  domain:  process.env.REACT_APP_DOMAIN,
  themePath:  process.env.REACT_APP_DOMAIN_THEME_PATH,
  endpoints: {
    settings: {
      en: process.env.REACT_APP_SETTINGS_EN,
      cy: process.env.REACT_APP_SETTINGS_CY
    },
    landing: process.env.REACT_APP_WHO_AM_I_LANDING,
    questions: process.env.REACT_APP_WHO_AM_I_QUESTIONS,
    type: process.env.REACT_APP_WHO_AM_I_TYPE
  },
  styleguide: process.env.REACT_APP_STYLEGUIDE,
  googleTagManager: {
    analytics: process.env.REACT_APP_GTM_ANALYTICS,
    marketing: process.env.REACT_APP_GTM_MARKETING,
    personalisation: process.env.REACT_APP_GTM_PERSONALISATION,
    webchat: process.env.REACT_APP_GTM_WEBCHAT
  },
  reciteMe: process.env.REACT_APP_RECITEME,
  disableLivechat: true,
  cw: {
    en: process.env.REACT_APP_CW_EN,
    cy: process.env.REACT_APP_CW_CY
  },
  ww: {
    en: process.env.REACT_APP_WW_EN,
    cy: process.env.REACT_APP_WW_CY
  },
  auth: {
    debug: false,
    autoLogin: false,
    clientId: process.env.REACT_APP_CLIENT_ID,
    authority: process.env.REACT_APP_AUTHORITY,
    redirectUri: {
      en: process.env.REACT_APP_BASEURL_EN + process.env.REACT_APP_WHO_AM_I_BASEPATH_EN,
      cy: process.env.REACT_APP_BASEURL_CY + process.env.REACT_APP_WHO_AM_I_BASEPATH_CY
    },
    profile: {
      en: process.env.REACT_APP_PROFILE_BASEPATH_EN,
      cy: process.env.REACT_APP_PROFILE_BASEPATH_CY
    }
  }
};